import { Box, Menu, MenuItem, Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { MenuItem as IMenuItem } from './Sidebar.interface';

import LockIconSvg from 'assets/collectiveIcons/LockIcon.svg';
import theme from 'theme';

export default function SubMenu({
    isOpen,
    anchorEl,
    onSelect,
    ...item
}: IMenuItem & {
    isOpen: boolean;
    anchorEl: HTMLLIElement | null;
    onSelect: (item?: IMenuItem) => void;
}) {
    const { pathname } = useLocation();
    const isSelected = (submenu: IMenuItem) => {
        const path = submenu.path || '';
        if (!path.includes('/', 1)) {
            return pathname === path;
        }
        return Boolean(path) && pathname.startsWith(path);
    };

    return (
        <Menu
            disablePortal
            open={isOpen}
            onClose={() => onSelect()}
            anchorEl={anchorEl}
            MenuListProps={{
                sx: {
                    paddingX: 1,
                },
            }}
            slotProps={{
                paper: {
                    elevation: 2,
                    sx: {
                        boxShadow: 'var(--Paper-shadow)',
                        marginLeft: 1,
                    },
                },
            }}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
            {item.submenu?.map((submenu) => (
                <MenuItem
                    key={submenu.name}
                    sx={{
                        typography: 'button',
                        color: 'cement.700',
                        borderRadius: 2,
                        paddingX: '10px',
                        marginX: 0,
                        marginY: 0.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 1,
                        '&.Mui-selected, &.Mui-selected:focus': { backgroundColor: 'cement.200' },
                        '&:first-of-type': { marginTop: 0 },
                        '&:last-of-type': { marginBottom: 0 },
                    }}
                    // aria-disabled rather than MUI's `disabled`: the latter sets pointer-events:none,
                    // which would swallow the hover the locked tooltip depends on.
                    aria-disabled={submenu.locked ? true : undefined}
                    tabIndex={submenu.locked ? -1 : undefined}
                    selected={isSelected(submenu)}
                    onClick={() => {
                        if (!submenu.locked) {
                            onSelect(submenu);
                        }
                    }}>
                    <Tooltip
                        title={submenu.locked && typeof submenu.lockedTooltip === 'string' ? submenu.lockedTooltip : ''}
                        placement="right"
                        describeChild>
                        <Box
                            component="span"
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 1,
                                width: '100%',
                            }}>
                            {submenu.name}
                            {submenu.locked && (
                                <Box
                                    component="img"
                                    src={LockIconSvg}
                                    alt="Lock"
                                    sx={{ width: theme.spacing(2), height: theme.spacing(2), opacity: 0.7 }}
                                />
                            )}
                        </Box>
                    </Tooltip>
                </MenuItem>
            ))}
        </Menu>
    );
}
